import React from 'react';
import NavbarComponent from '../pages/Navbar'; // ✅ correct path
import Footer from '../Footer';               // ✅ correct path
import VideoBanner from './VideoBanner'; // ✅ fixed casing

import UpcomingEvents from './UpcomingEvents';

const VideoSection = () => {
  return (
    <>
      <NavbarComponent />
      <VideoBanner />
      <UpcomingEvents/>
      <Footer />
    </>
  );
};

export default VideoSection;
